export const SURVEY_ROLES = [
  { value: 'organization_admin', label: 'organization_admin' },
  { value: 'country_admin', label: 'country_admin' },
  { value: 'regional_admin', label: 'regional_admin' },
  { value: 'clinic_admin', label: 'clinic_admin' },
  { value: 'phc_service_admin', label: 'phc_service_admin' },
  { value: 'therapist', label: 'therapist' },
  { value: 'phc_worker', label: 'phc_worker' },
  { value: 'patient', label: 'patient' }
];

export const SURVEY_LOCATION = [
  { value: 'rural_area', label: 'rural_area' },
  { value: 'urban_area', label: 'urban_area' },
  { value: 'n/a', label: 'n/a' }
];

export const SURVEY_FREQUENCY_OPTIONS = [
  { value: 'weekly', label: 'weekly' },
  { value: 'daily', label: 'daily' }
];

export const SURVEY_FREQUENCY = {
  WEEKLY: 'weekly',
  DAILY: 'daily'
};

export const SURVEY_SERVICE_TYPES = {
  REHAB_SERVICE: 'rehab_service',
  PHC_SERVICE: 'phc_service'
};

export const SURVEY_SERVICE_TYPE_OPTIONS = [
  { value: 'rehab_service', label: 'rehab_service' },
  { value: 'phc_service', label: 'phc_service' },
];
